import React from 'react';
import { ACCENT_COLOR } from './colors';

const Cart = ({
  width = 18,
  className = '',
}) => (
  <svg
    className={`svg-icon ${className || ''}`}
    width={width}
    height={width}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path d="M15 16H4V3H15V16Z" stroke="#333333" strokeWidth="2" />
    <path d="M2 3H17" stroke="#333333" strokeWidth="2" />
    <path d="M8 1H11" stroke="#333333" strokeWidth="2" />
    <path d="M7 6H9V14H7V6Z" fill={ACCENT_COLOR} />
    <path d="M10 6H12V14H10V6Z" fill={ACCENT_COLOR} />
  </svg>
);

export default Cart;
